
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/louer",
      function () {
        return require("private-next-pages/louer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/louer"])
      });
    }
  